import dayjs from "dayjs"
import { BillTemplateGet } from "../../../../data/Types"
import { returnAddressString, returnMonthNames } from "../../../../services/functions"
import { ObjectType } from "../../../Objekte/types/types"
import HeadTableRow from "../HeadTableRow"

type BillDetailHeadType = {
    data: BillTemplateGet
}

export default function BillTemplateHeadBanner(props: BillDetailHeadType) {
    return (
        <div className="flex gap-4 h-fit text-sm">
            {/* Basic Information about Bill */}
            <div className="w-full h-fit rounded-default shadow-lg mt-6 bg-white p-4">
                <HeadTableRow link={"/kunden/" + props.data?.customer_id?._id} info={"Kunde"} content={props.data?.customer_id?.customer?.name} />
                {props.data?.object_id && (
                    <HeadTableRow
                        link={"/objekte/" + props.data?.object_id?._id}
                        info={"Objekt"}
                        content={returnAddressString(props.data?.object_id as ObjectType)}
                    />
                )}
                <HeadTableRow info={window.innerWidth > 640 ? "erstellt am" : "erstellt"} content={dayjs(props.data.date).format("DD.MM.YYYY")} />
                <HeadTableRow info={"Kategorie"} content={props.data?.billTemplateCategorie} />
                <HeadTableRow info={"Archiviert"} content={props.data?.archived ? "Ja" : "Nein"} />
                <HeadTableRow info={"Rechnungstag"} content={props.data.billDay + ". eines Monats"} />
                <HeadTableRow info={"Zahlungsfrist"} content={props.data.billDue + " Tage"} />
                <HeadTableRow info={"Interval"} content={returnMonthNames(props.data.intervalMonths)} />
                <HeadTableRow
                    info={"Mahnungssystem"}
                    content={`nach ${props.data.reminderStartOffsetInDays} Tagen Zahlungsverzug, im Abstand von ${props.data.reminderIntervalInDays} Tagen, maximal ${props.data.maxReminders} Mahnungen`}
                />
            </div>
        </div>
    )
}
